export const styles = {
    queryList: {
        padding: 0
    },
    sidebar: {
        maxWidth: "338px",
        borderRight: "1px solid",
        borderColor: "greyscale.200",
        display: "flex",
        flexDirection: "column",
        minHeight: "500px",
        height: "100%"
    },
    sidebarScrollable: {
        flex: 1,
        overflowY: "auto"
    },
    sidebarItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.5,
        cursor: "pointer",
        backgroundColor: "additional.white",
        border: "none",
        "&:hover": {
            backgroundColor: "greyscale.50"
        }
    },
    sidebarItemSelected: {
        backgroundColor: "greyscale.100"
    },
    sidebarItemLeft: {
        display: "flex",
        alignItems: "center",
        gap: 1
    },
    identifierLabel: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "200px"
    },
    deleteIcon: {
        cursor: "pointer",
        height: "18px",
        "& > svg": {
            width: "18px",
            height: "18px"
        },
        "& path": {
            fill: "none",
            stroke: ({ palette }) => palette.critical[500]
        }
    },
    dragIcon: {
        color: "greyscale.400",
        fontSize: "20px",
        cursor: "grab"
    },
    rightSection: {
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        flex: 1,
        minWidth: 0,
        height: "100%",
        overflowY: "auto"
    },
    queryEditorContainer: {
        flex: 1,
        ml: -3,
        mt: -3,
        cursor: "text",
        "& .CodeMirror": {
            borderRadius: "0 0 8px 8px",
            minHeight: "300px",
            height: "100%",
            marginLeft: "8px"
        },
        "& .CodeMirror:hover": {
            borderColor: "greyscale.300"
        },
        "& .CodeMirror:focus-within": {
            borderColor: "secondary.300"
        },
        "& .CodeMirror-vscrollbar": {
            overflowY: "auto !important"
        },
        "& .CodeMirror-hscrollbar": {
            overflowX: "auto !important"
        }
    },
    addQueryButton: {
        mx: 2,
        my: 1.5
    },
    dialog: {
        ".MuiDialog-paper": {
            minWidth: "900px",
            maxWidth: "80vw"
        },
        ".MuiDialogContent-root": {
            my: -3,
            p: 0
        }
    },
    sidebarItemError: {
        backgroundColor: "critical.50",
        "&:hover": {
            backgroundColor: "critical.100"
        }
    },
    sidebarItemErrorSelected: {
        backgroundColor: "critical.100"
    },
    sidebarErrorIcon: {
        color: "critical.500",
        fontSize: "18px"
    },
    sidebarSuccessIcon: {
        color: "success.500",
        fontSize: "18px"
    },
    validationFeedback: {
        mt: 1
    },
    errorChip: {
        cursor: "pointer"
    },
    errorChipContainer: {
        display: "flex",
        justifyContent: "flex-end"
    },
    validateProgressBar: {
        height: 8,
        borderRadius: 1,
        backgroundColor: "greyscale.200",
        " .MuiLinearProgress-bar": {
            borderRadius: 1
        }
    },
    headerDivider: {
        mx: -3,
        borderBottom: "1px solid",
        borderColor: "greyscale.200"
    },
    disabledPrimaryBtn: {
        opacity: 0.5,
        pointerEvents: "none",
        cursor: "not-allowed"
    },
    tabLabelWithIcon: {
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5
    },
    tabWarningIcon: {
        fontSize: 16,
        color: "warning.500"
    },
    emptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "620px",
        gap: 1
    },
    emptyStateImage: {
        width: "200px",
        height: "auto"
    },
    emptyStateText: {
        mt: 2
    },
    tabsWrapper: {
        position: "relative"
    },
    guidelinesLink: {
        position: "absolute",
        top: 8,
        right: 0,
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        cursor: "pointer",
        zIndex: 1
    },
    guidelinesLinkIcon: {
        display: "inline-flex",
        alignItems: "center",
        "& svg": {
            width: 18,
            height: 18,
            fill: "none",
            "& > path": {
                stroke: ({ palette }) => palette.secondary.main
            }
        }
    },
    guidelinesTooltipPaper: {
        maxWidth: "none"
    },
    guidelinesTooltipContent: {
        display: "flex",
        flexDirection: "column",
        gap: 0.75,
        py: 0.5,
        whiteSpace: "nowrap"
    },
    guidelinesTooltipRow: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        whiteSpace: "nowrap"
    },
    guidelinesTooltipIcon: {
        display: "inline-flex",
        alignItems: "center",
        "& svg": {
            width: 20,
            height: 20,
            fill: "none"
        }
    },
    guidelinesTooltipCheckIcon: {
        display: "inline-flex",
        alignItems: "center",
        "& svg": {
            width: 20,
            height: 20,
            fill: "none",
            "& > path": {
                stroke: ({ palette }) => palette.additional.white
            }
        }
    }
};
